/**
 * MediaField — thin wrapper kept for the ABMHC CMS call sites. Everything now
 * goes through MediaUpload, so files land in object storage and there is no
 * URL box to paste into.
 */
import React from 'react';

import { MediaUpload } from '@/components/MediaUpload';

const purposeFor = (accept = '') => {
  if (accept.includes('video') && accept.includes('image')) return 'gallery';
  if (accept.includes('video')) return 'video';
  return 'photo';
};

const MediaField = ({ value, onChange, accept = 'image/*,video/*', label, testId }) => (
  <MediaUpload
    value={value || ''}
    onChange={(url) => onChange(url)}
    purpose={purposeFor(accept)}
    label={label}
    testId={testId || 'media-field'}
  />
);

export default MediaField;
